import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ElementRef,
  HostListener
} from '@angular/core';

@Component({
  selector: 'awair-info-button',
  templateUrl: './info-button.component.html',
  styleUrls: ['./info-button.component.scss']
})
export class InfoButtonComponent implements OnInit {
  color: string = '#CDD3D8';

  @HostListener('mouseover') mouseOver() {
    this.color = '#ACB4BB';
  }
  @HostListener('mouseout') mouseOut() {
    if (!this.isActive) { this.color = '#CDD3D8'; }
  }
  @HostListener('document:click', ['$event']) documentClick(event: any) {
    // If itself is selected, then emit true, else emit false
    this.selected.emit(!!this.el.nativeElement.contains(event.target));
  }

  @Output() selected: EventEmitter<boolean> = new EventEmitter();

  get isActive(): boolean {
    return this._isActive;
  }
  @Input()
  set isActive(value: boolean) {
    this._isActive = value;
    this.color = this._isActive ? '#ACB4BB' : '#CDD3D8';
  }
  private _isActive: boolean;

  constructor(private el: ElementRef) {
  }

  ngOnInit() {
  }
}
